import { Badge } from '@/components/ui/badge';
import { useTranslation } from 'react-i18next';
import { usePlanRestrictions } from '@/hooks/usePlanRestrictions';
import { Zap, Crown, Building2, Wrench } from 'lucide-react';

const TIER_CONFIG = {
  starter: { label: 'Starter', icon: Zap, className: 'bg-blue-500/10 text-blue-400 hover:bg-blue-500/10' },
  professional: { label: 'Professional', icon: Crown, className: 'bg-violet-500/10 text-violet-400 hover:bg-violet-500/10' },
  business: { label: 'Business', icon: Building2, className: 'bg-indigo-100 text-indigo-700 hover:bg-indigo-100' },
  internal: { label: 'Internal', icon: Wrench, className: 'bg-secondary text-muted-foreground hover:bg-secondary' },
};

interface PlanBadgeProps {
  showIcon?: boolean;
  className?: string;
}

const PlanBadge = ({ showIcon = true, className }: PlanBadgeProps) => {
  const { t } = useTranslation('subscription');
  const { tier, isLoading, isTrialing } = usePlanRestrictions();

  if (isLoading || !tier) return null;

  const config = TIER_CONFIG[tier as keyof typeof TIER_CONFIG];
  if (!config) return null;

  const Icon = config.icon;

  return (
    <Badge variant="outline" className={`text-xs font-medium ${config.className} ${className ?? ''}`}>
      {showIcon && <Icon className="h-3 w-3 mr-1" />}
      {config.label}
      {isTrialing && <span className="ml-1 opacity-70">· {t('planBadge.trial', { defaultValue: 'Trial' })}</span>}
    </Badge>
  );
};

export default PlanBadge;
